import { Extensions } from '@tiptap/core'
import Document from '@tiptap/extension-document'
import HardBreak from '@tiptap/extension-hard-break'
import Highlight from '@tiptap/extension-highlight'
import History from '@tiptap/extension-history'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'
import TextAlign from '@tiptap/extension-text-align'
import Typography from '@tiptap/extension-typography'
import Underline from '@tiptap/extension-underline'
import { Editor } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import { Button } from '../nodes/button'
import { CustomImage } from '../nodes/image'
import { CustomLink } from '../nodes/link'
import { Spacer } from '../nodes/spacer'
import { Variable } from '../nodes/variable'

export type EditorMenuExtension = 'starter' | 'image' | 'align' | 'headers' | 'email' | 'campaign'
export const DefaultEditorMenuExtension: EditorMenuExtension[] = [
  'starter',
  'image',
  'align',
  'headers',
]
export const generateExtensions = (extensions: EditorMenuExtension[]): Extensions =>
  extensions.length === 0
    ? [Document, Paragraph, Text, HardBreak, History]
    : [
        Highlight,
        ...(extensions.includes('image') ? [CustomImage] : []),
        CustomLink.configure({
          openOnClick: false,
          linkOnPaste: true,
        }),
        StarterKit.configure({
          heading: extensions.includes('headers')
            ? {}
            : {
                levels: [],
              },
        }),
        ...(extensions.includes('align')
          ? [
              TextAlign.configure({
                types: ['heading', 'paragraph'],
              }),
            ]
          : []),
        Typography,
        Underline,
        ...(extensions.includes('email') && !extensions.includes('campaign')
          ? [Spacer, Button]
          : []),
        ...(extensions.includes('campaign') ? [Spacer, Button, Variable] : []),
      ]
export const hasExtension = (editor: Editor, name: string): boolean =>
  !!editor?.extensionManager.extensions.some((e) => e.name === name)
